import { useUser } from "@clerk/clerk-react";
import { useTheme } from "next-themes";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function PreferencesSync() {
  const { user, isLoaded } = useUser();
  const { setTheme } = useTheme();
  const { i18n } = useTranslation();
  const lastSyncedUserId = useRef(null);

  useEffect(() => {
    if (!isLoaded || !user) {
      lastSyncedUserId.current = null;
      return;
    }
    if (lastSyncedUserId.current === user.id) return;
    lastSyncedUserId.current = user.id;

    const rawMetadata = user.unsafeMetadata;
    const metadata =
      rawMetadata && typeof rawMetadata === "object"
        ? /** @type {Record<string, unknown>} */ (rawMetadata)
        : {};
    const theme = typeof metadata.theme === "string" ? metadata.theme : null;
    const language = typeof metadata.language === "string" ? metadata.language : null;

    if (theme && ["light", "dark", "system"].includes(theme)) {
      setTheme(theme);
    }
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [isLoaded, user, setTheme, i18n]);

  return null;
}
